export function downloadFromUrl(url: string) {
  const link = document.createElement('a')
  link.href = url
  link.download = ''
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  link.parentNode?.removeChild(link)
}

export function saveExcel(blob: Blob) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `POM-Specifications.xlsx`)
  document.body.appendChild(link)
  link.click()
  link.parentNode?.removeChild(link)
}

export function saveOrderExcel(blob: Blob, name?: string) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${name ?? 'Order-template'}.xlsx`)
  document.body.appendChild(link)
  link.click()
  link.parentNode?.removeChild(link)
}

export function savePdf(
  blob: Blob,
  name?: string,
  postfix: '.pdf' | '' = '.pdf'
) {
  const pdfName = name ? `${name}${postfix}` : `report_${Date.now()}${postfix}`
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.setAttribute('download', pdfName)
  document.body.appendChild(link)
  link.click()
  link.parentNode?.removeChild(link)
}
